import { CompanyReadinessView } from '@/features/CompanyReadiness/CompanyReadinessView';

export function BatchCompanyReadinessTab({ batchId }: { batchId: string }) {
  return <CompanyReadinessView fixedBatchId={batchId} />;
}
